import React, { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";

import NavigationContainer from "./containers/NavigationContainer";
import RootErrorFallback from "./errors/rootError";
import { useMe } from "./hooks/queries";
import DataSvc from "./services/dataSvc";
import DemoModeSvc from "./services/demoModeSvc";
import { setUserDimensions } from "./utils/ga";

import "react-toastify/dist/ReactToastify.css";
interface IAppProps {
  loading: boolean;
}

const App: React.FunctionComponent<IAppProps> = ({ loading, children }) => {
  const { data: me } = useMe();
  useEffect(() => {
    setUserDimensions(me);
  }, [me]);

  useEffect(() => {
    DemoModeSvc.current.addDemoListeners();
  }, []);

  const handleError = async (error: any, info: { componentStack: string }) => {
    await DataSvc.createErrorLogs({
      type: "client",
      status_code: null,
      created_by: Number(DataSvc.userId) || null,
      details: {
        url: error?.config?.url || null,
        method: error?.config?.method || null,
        title: error?.message || "Unknown Error",
        errorMessage: error?.message || null,
        errorJson: JSON.stringify(error) || null,
        errorItem: null,
        stack: error?.stack || info?.componentStack || null,
        timestamp: new Date().toISOString(),
        userId: DataSvc.userId || null,
        orgId: DataSvc.orgId || null,
        websiteUrl: typeof window !== "undefined" ? window.location.href : null,
      },
    });
  };

  return (
    <div className={loading ? "loading" : ""}>
      <ErrorBoundary
        FallbackComponent={RootErrorFallback}
        onError={handleError}
      >
        <NavigationContainer>{children}</NavigationContainer>
        <ToastContainer hideProgressBar={true} limit={5} />
      </ErrorBoundary>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  loading: state.dataReducer.loading,
});

const matchDispatchToProps = () => ({});

export default connect(mapStateToProps, matchDispatchToProps)(App);
